import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback, CompensationSentence } from 'types';

export const fetchCompensationSentences = createAction(
  'compensation-sentences/fetch',
  (callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { callback },
  })
);

export const fetchedCompensationSentences = createAction(
  'compensation-sentences/fetched',
  (data?: Array<CompensationSentence>, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchCompensationSentences,
  fetchedCompensationSentences,
};
